import { useEffect, useRef } from "react";
import { DingTerminal } from "../../../components/terminal/DingTerminal";

export default function Hero() {
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = heroRef.current?.querySelectorAll(".reveal");
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="hero"
      ref={heroRef}
      className="relative min-h-screen flex flex-col items-center justify-center px-4 md:px-8 lg:px-16 py-20"
    >
      <div className="max-w-6xl w-full flex flex-col items-center text-center">
        
        {/* Tagline */}
        <h1 className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out delay-100 text-3xl md:text-5xl lg:text-6xl font-bold font-mono text-ding-cream tracking-tight mb-6">
          realtime. backend. tools.
          <br />
          <span className="text-ding-phosphor">games. shipped.</span>
        </h1>

        {/* Description */}
        <p className="reveal opacity-0 translate-y-6 transition-all duration-700 ease-out delay-200 text-ding-dim text-base md:text-lg leading-relaxed mb-10">
          d!ng builds realtime systems, backend services, developer tooling, and multiplayer technology.
        </p>

        <DingTerminal sequenceName="development" />
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-ding-dim rounded-full flex justify-center pt-2">
          <div className="w-1 h-2 bg-ding-phosphor rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
}